import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import "react";
import * as __WEBPACK_EXTERNAL_MODULE_clsx_lite_e67b6d69__ from "clsx/lite";
import * as __WEBPACK_EXTERNAL_MODULE__types_mjs_4ad50757__ from "./types.mjs";
const Heading = ({ as, size, weight = 'regular', children, className, ...props })=>{
    const RootHeading = as;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(RootHeading, {
        ...props,
        className: (0, __WEBPACK_EXTERNAL_MODULE_clsx_lite_e67b6d69__["default"])(__WEBPACK_EXTERNAL_MODULE__types_mjs_4ad50757__.HeadingSize[size], __WEBPACK_EXTERNAL_MODULE__types_mjs_4ad50757__.HeadingWeight[weight], className),
        children: children
    });
};
export { Heading };
